<template>
    <section class="message-show"
             :class="{'loading': infos.length <= 0}"
    >
        <dl class="message-dl"
            :class="getDlcls(item.status, item.username)"
            v-for="(item, index) in infos"
            :key="item.username"
            :data-index="index"
        >
            <dt class="message-dt">
                <div class="avatar">
                    <img :src="item.avatar">
                </div>
                <div class="soldier">
                    <p class="row">
                        <span class="is-me" v-show="myname == item.username">我</span>
                        <span class="is-captain" v-if="item.username == captain">队长</span>
                        <span class="name">{{ item.realname }}</span>
                        <span class="label">代号 <strong>{{ item.label }}</strong></span>
                        <em class="u-status"
                            :class="getStatus(item.status, 'class')"
                        >
                            {{ getStatus(item.status) }}
                        </em>
                    </p>
                    <p class="row">
                        最新发布于 <span class="lastsay-date">{{ item.lastsay }}</span>
                    </p>
                </div>
            </dt>
            <dd class="message-dd">
                <div class="say-box" v-show="item.say" v-html="item.say"></div>
            </dd>
        </dl>
        <div class="outline-quick" v-show="infos.length > 0">
            <button type="button" @click="toggleOutline">{{ quickBtnText }}</button>
            <p>{{ quickBtnTips }}</p>
        </div>
    </section>
</template>

<script>
    import {postOutline} from '@/api/post.js';
    import {STATUS} from '@/common/const.js';

    export default {
        name: "message-show",
        props: {
            infos: {
                type: Array,
                default() {
                    return []
                }
            },
            captain: {
                type: String,
                default() {
                    return 'nobody'
                }
            },
            myStatus: {
                type: Number,
                default() {
                    return STATUS.outline
                }
            }
        },
        data() {
            return {
                myname: window.setting.userInfo.username

            }
        },
        computed: {
            quickBtnText() {
                if (this.myStatus == STATUS.outline) {
                    return '上 线';
                } else {
                    return '离 线';
                }
            },
            quickBtnTips() {
                if (this.myStatus == STATUS.outline) {
                    return '点击刷新，即可重新上线';
                } else {
                    return '离开的时候，务必要点一下';
                }
            }
        },
        mounted() {

        },
        methods: {
            getDlcls(status, username) {
                let cls = '';
                if (status == STATUS.outline && this.myname == username) {
                    cls = 'outline';
                }
                if (status == STATUS.outline && this.myname != username) {
                    cls = 'outline hide';
                }
                return cls;
            },
            getStatus(status, type = '') {
                let str = '';
                status = parseInt(status);
                switch (status) {
                    case 0:
                        str = (type == 'class') ? 'outline' : '离线';
                        break;
                    case 1:
                        str = (type == 'class') ? 'online' : '在线';
                        break;
                    case 2:
                        str = (type == 'class') ? 'waiting' : '挂机';
                        break;
                }
                return str;
            },
            async toggleOutline() {
                // 如果是离线模式 点击就是刷新
                if (this.myStatus == STATUS.outline) {
                    window.location.reload();
                } else {
                    const isOutLine = await postOutline(this.myname);
                    console.log(isOutLine);
                }
            }
        }
    }
</script>

<style scoped>
    .outline-quick {
        text-align: center;
        margin-top: 20px;
    }

    .outline-quick button {
        width: 60%;
        line-height: 50px;
        background: #ff0000;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        border-radius: 50px;
        display: block;
        margin: 0 auto 10px;
    }
    .outline-quick button:active{
        background-color: #d30303;
    }

    .message-show{
        min-height: 150px;
    }
    .message-show.loading{
        background-image: url("loading-pc.gif");
        background-position: center center;
        background-repeat: no-repeat;
    }

    .message-dl {
        padding: 15px;
        width: 100%;
    }

    .message-dl.outline {
        opacity: 0.9;
        filter: grayscale(100%);
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)
    }

    .message-dl.outline.hide {
        display: none;
    }

    .message-dt {
        display: flex;
        width: 100%;
    }

    .avatar {
        width: 60px;
        height: 60px;
        margin-right: 13px;
    }

    .soldier {
        height: 55px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        color: #707070;
        width: 100%;
    }

    .soldier .row {
        width: 100%;
        position: relative;
    }

    .soldier .row:first-child {
    }

    .soldier span {
        margin-right: 10px;
        line-height: 24px;
        height: 24px;
        display: inline-block;
    }

    .is-captain {
        background: #EE5B5B;
        color: #fff;
        padding: 0 8px;
        border-radius: 5px;
    }

    .is-me {
        background: #7D4228;
        color: #fff;
        padding: 0 8px;
        border-radius: 5px;
    }

    .say-box {
        background: #fff;
        padding: 15px;
        position: relative;
        margin-top: 12px;
    }

    .say-box:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #fff transparent;
        top: -10px;
        left: 20px;
    }

    .u-status {
        position: absolute;
        right: 0;
        line-height: 24px;
    }

    .u-status:before {
        content: "·";
        font-size: 30px;
        line-height: 29px;
        display: inline-block;
        vertical-align: top;
        padding-right: 3px;
    }

    .u-status.online {
        color: #1fa128;
    }

    .u-status.waiting {
        color: #D06B41;
    }
</style>
